import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChartsModule, ThemeService } from 'ng2-charts';

import { AppComponent } from './app.component';
//import { NavbarComponent } from './shared/components/navbar/navbar.component';
//import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
//import { FooterComponent } from './shared/components/footer/footer.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TodoComponent } from './apps/todo-list/todo/todo.component';
import { TodoListComponent } from './apps/todo-list/todo-list.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { SpinnerModule } from '../app/spinner/spinner.module';
import { SharedModule } from './shared/shared.module';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';
import { AuthInterceptor } from './core/services/auth.interceptor';
import { LoginService} from './core/services/login.service';

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    TodoListComponent,
    TodoComponent,
    /*,
    ContentAnimateDirective*/
    /*SpinnerComponent*/
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    HttpClientModule,
    SpinnerModule,
    SharedModule,
    NgxQRCodeModule,
    ToastrModule.forRoot()
  ],
  providers: [ThemeService, { provide: LOCALE_ID, useValue: 'es' },LoginService,{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
